export default __webpack_public_path__ + "atomic/_patterns/01-atoms/comma-separated-link-list/_comma-separated-link-list.twig";